import React from 'react'
import { Card, CardBody, CardTitle } from 'reactstrap'
import { useSelector } from 'react-redux'

import SocialMediaSummaryCard from '../Services/SocialMedia/SummaryCard'
import PaidAdsSummaryCard from '../Services/PaidAds/SummaryCard'
import { serviceMap } from '../../../utils/common'

function Review(){
    const model = useSelector(state => state.site.model)

    const { siteForm } = model
    return <>
        <div class="d-flex justify-content-center align-items-start">
            <Card
                className="my-2"
                style={{
                    maxWidth: "50em",
                    border: "1px solid #ccc"
                }}
            >
                <CardBody>
                    <CardTitle tag="h4">
                        <img src={serviceMap.ga.img} class="mr-2 rounded img-thumbnail" style={{width:"40px"}} />
                        {serviceMap.ga.titleUnformatted}
                    </CardTitle>
                    <h4>
                        <small class="text-muted">Account:</small> {siteForm?.attr?.accounts?.ga?.accountName}
                    </h4>
                    <h4>
                        <small className="text-muted">Property:</small> {siteForm?.attr?.accounts?.ga?.propertyName}
                    </h4>
                    {!siteForm?.attr?.accounts?.ga?.tokenId?.includes("ga4:") && <h4>
                        <small className="text-muted">View:</small> {siteForm?.attr?.accounts?.ga?.viewName}
                    </h4>}
                </CardBody>
            </Card>
        </div>
        <div class="d-none d-sm-flex justify-content-center align-items-start">
            {!siteForm?.attr?.expediteOnboarding && <div className="mr-sm-4 review-step-summary">
                <SocialMediaSummaryCard showEditButtons />
            </div>}
            <div className="review-step-summary">
                <PaidAdsSummaryCard showEditButtons />
            </div>
        </div>
        <div className="d-flex d-sm-none row">
            {!siteForm?.attr?.expediteOnboarding && <div className="col-12">
                <SocialMediaSummaryCard showEditButtons />
            </div>}
            <div className="col-12">
                <PaidAdsSummaryCard showEditButtons />
            </div>
        </div>
    </>
}

export default Review